import { Button, Form, message, Select } from "antd";
import React, { useEffect, useRef, useState } from "react";

// import {
//   aadharPattern,
//   filterOption,
//   getLocalStorageItem,
//   mobilePattern,
//   setLocalStorageItem,
// } from "../../../Utils";
import { useNavigate, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  aadharPattern,
  filterOption,
  getLocalStorageItem,
  messageConfiguration,
  mobilePattern,
  setLocalStorageItem,
} from  "../../../../../Utils";
import CommonInput from "../../../../../Common/CommonInput";

const DetailPage = (props) => {
  const [form] = Form.useForm();

  const formref = useRef();

  const userBankName = localStorage.getItem("user_bank_name");
  const customerAadhaarNumber = localStorage.getItem("customer_aadhaar_number");
  const mobileNum = localStorage.getItem("mobile_num");

  // Check if all required values are present
  const areDetailsPresent = userBankName && customerAadhaarNumber && mobileNum;

  const handleValidationFailed = (errorInfo) => {
    // console.log("Validation Failed:", errorInfo);
  };

  const handleLocalStorage = (val) => {
    console.log(val, "local");

    if (val?.customer_mobile)
      setLocalStorageItem("mobile_num", val.customer_mobile);

    if (val?.customer_aadhaar_number)
      setLocalStorageItem(
        "customer_aadhaar_number",
        val.customer_aadhaar_number
      );

    if (val?.user_bank?.value)
      setLocalStorageItem("user_bank_value", val.user_bank.value);

    if (val?.user_bank?.label)
      setLocalStorageItem("user_bank_name", val.user_bank.label);

    props.areDetailsPresent(true);
  };

  useEffect(() => {
    getLocalStorageItem("mobile_num")
    getLocalStorageItem("customer_aadhaar_number")
    getLocalStorageItem("user_bank_name")

    if (customerAadhaarNumber && mobileNum && userBankName) {
      props.areDetailsPresent(true)
    }
  }, [])




  useEffect(() => {
    getLocalStorageItem("mobile_num");
    getLocalStorageItem("customer_aadhaar_number");
    getLocalStorageItem("user_bank_name");

  }, []);

  return (
    <div className="grid grid-cols-1 md:grid-cols-1 pb-11 place-items-start">
      <div className="prepaid animate-slide-in w-full  bg-white shadow-normal rounded-3xl p-5">
        <p className="font-bold text-[15px] mb-2">
          Fill all the Required details
        </p>
        <Form
          form={form}
          ref={formref}
          name="basic"
          initialValues={{
            remember: true,
          }}
          onFinish={(val) => handleLocalStorage(val)}
          onFinishFailed={handleValidationFailed}
        >
          <Form.Item
            name={`customer_mobile`}
            label={"Mobile Number"}
            labelCol={{ span: 24 }}
            rules={[
              {
                required: getLocalStorageItem("mobile_num") ? false : true,
                message: "Enter Mobile Number!",
              },
              {
                pattern: mobilePattern,
                message: "Invalid mobile number format!",
              },
              {
                whitespace: true,
                message: "Field cannot contain only blank spaces",
              },
            ]}
          >
            <CommonInput
              placeholder="Enter Your Mobile Number"
              // defaultValue={getLocalStorageItem("mobile_num")}
              onInput={(e) => {
                const value = e.target.value.replace(/\D/g, "");
                e.target.value = value;
              }}
              name="customer_mobile"
            />
          </Form.Item>
          <Form.Item
            name={`customer_aadhaar_number`}
            label={"Aadhar Number"}
            labelCol={{ span: 24 }}
            rules={[
              {
                required: getLocalStorageItem("customer_aadhaar_number")
                  ? false
                  : true,
                message: "Enter aadhar Number!",
              },
              {
                pattern: aadharPattern,
                message: "Invalid aadhar number format!",
              },
              {
                whitespace: true,
                message: "Field cannot contain only blank spaces",
              },
            ]}
          >
            <CommonInput
              // defaultValue={getLocalStorageItem("customer_aadhaar_number")}

              onInput={(e) => {
                const value = e.target.value.replace(/\D/g, "");
                e.target.value = value;
              }}
              placeholder="Enter Aadhar Number"
              name="customer_aadhaar_number"
            />
          </Form.Item>{" "}
          <Form.Item
            name={`user_bank`}
            label={"Select Bank"}
            labelCol={{ span: 24 }}
            rules={[
              {
                required: getLocalStorageItem("user_bank_value") ? false : true,
                message: "Select one bank!",
              },
            ]}
          >
            <Select
              showSearch
              labelInValue={true}
              // defaultValue={getLocalStorageItem("user_bank_name")}
              placeholder="Select a bank"
              filterOption={filterOption}
              className="w-full"
              options={props.banks}
            />
          </Form.Item>
          <Form.Item>
            <Button
              style={{ background: "var(--primary)" }}
              className="w-full bg-primary text-white hover:bg-primary border-none mt-4"
              htmlType="submit"
            >
              Continue
            </Button>
          </Form.Item>
        </Form>
      </div>
    </div>
  );
};

export default DetailPage;
